import { Control, Controller, FieldError, FieldValues } from 'react-hook-form';
import FormFieldContainer from '../form-field-container.tsx/form-field-container';
import { FieldName } from '../core/field-name';

interface InputFormFieldProps<TValue, TForm extends FieldValues, TName extends FieldName<TForm, TValue>> {
	label?: string;
	type: string;
	placeholder?: string;
	readOnly?: boolean;
	onFocus?: () => void;
	onChange?: (value: string) => void;
	control?: Control<TForm>;
	name: TName;
	error?: FieldError;
	className?: string;
	id?: string;
}

const InputFormField = <TValue, TForm extends FieldValues, TName extends FieldName<TForm, TValue>>({
	label,
	type,
	placeholder,
	onFocus,
	className,
	control,
	name,
	error,
	readOnly,
	onChange,
}: InputFormFieldProps<TValue, TForm, TName>) => {
	return (
		<FormFieldContainer label={label} error={error} className={className}>
			<Controller
				control={control}
				name={name}
				render={({ field: { onChange: fieldOnChange, ...field } }) => (
					<input
						essence-input="true"
						className={className ?? ''}
						type={type}
						placeholder={placeholder}
						onFocus={onFocus}
						show-error={error?.message}
						step="0.01"
						readOnly={readOnly}
						onChange={e => {
							const value = e.target.value;
							fieldOnChange(e);
							onChange?.(value);
						}}
						{...{
							...field,
							value: field.value,
						}}
					/>
				)}
			/>
		</FormFieldContainer>
	);
};

export default InputFormField;
